import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { useExtra } from 'apps/auth/hooks/selectors';

import FeedbackCancellationReasons from './FeedbackCancellationReasons';

const CanceledOperationModal = (props) => {
    const { feedbackCancellationReasons } = useExtra();
    const [showFeedbackCancellationReasons, toggleShowFeedbackCancellationReasons] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (feedbackCancellationReasons) {
                toggleShowFeedbackCancellationReasons(true);
            } else {
                props.toggleSpinner(true);
                location.reload();
            }
        }, 2000);
    }, [feedbackCancellationReasons]);

    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            {showFeedbackCancellationReasons && <FeedbackCancellationReasons />}
            {!showFeedbackCancellationReasons && <InfoPage insideModalComponent animatedIconSuccess mainText={props.transactionCanceled} />}
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        transactionCanceled: state.messages.pageMessages.transactionCanceled,
    };
};
export default connect(mapStateToProps, { toggleSpinner })(CanceledOperationModal);
